import { render, staticRenderFns } from "./SelectMetodosPospago.vue?vue&type=template&id=12f62684&"
import script from "./SelectMetodosPospago.vue?vue&type=script&lang=js&"
export * from "./SelectMetodosPospago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports